var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospitals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 3.5C15.75 1.567 17.317 0 19.25 0H29.75C31.683 0 33.25 1.567 33.25 3.5V5.25C33.25 7.183 31.683 8.75 29.75 8.75H19.25C17.317 8.75 15.75 7.183 15.75 5.25V3.5ZM37.625 3.5H39.375C42.2745 3.5 44.625 5.85051 44.625 8.75V43.75C44.625 46.6495 42.2745 49 39.375 49H9.625C6.72551 49 4.375 46.6495 4.375 43.75V8.75C4.375 5.85051 6.72551 3.5 9.625 3.5L11.375 3.5V5.25C11.375 9.59925 14.9008 13.125 19.25 13.125H29.75C34.0992 13.125 37.625 9.59924 37.625 5.25V3.5ZM20.8889 20.8179C20.8889 20.0596 21.5037 19.4448 22.262 19.4448H26.7247C27.483 19.4448 28.0978 20.0596 28.0978 20.8179V26.2789L33.5587 26.2789C34.3171 26.2789 34.9318 26.8936 34.9318 27.652V32.1146C34.9318 32.873 34.3171 33.4877 33.5587 33.4877H28.0978L28.0976 38.9487C28.0976 39.707 27.4828 40.3218 26.7245 40.3218H22.2618C21.5035 40.3218 20.8887 39.707 20.8887 38.9487V33.4877H15.4278C14.6695 33.4877 14.0547 32.873 14.0547 32.1146V27.652C14.0547 26.8936 14.6695 26.2789 15.4278 26.2789H20.8889V20.8179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitals);
export default __webpack_public_path__ + "static/media/Hospitals.1666a2d804bfcf0a79a6120be63fbfcb.svg";
export { ForwardRef as ReactComponent };